var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"gu24__logo",attrs:{"href":("https://24guru.by/" + (_vm.$i18n.locale)),"title":_vm.$t('msgs.toMain')}},[_c('div',{staticClass:"gu24__logo__image"})])}
var staticRenderFns = []

export { render, staticRenderFns }